import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { AUTHORIZATION_PATH, REGISTRATION_PATH } from '@app/constants';

export const useLayoutLogin = () => {
  const { pathname } = useLocation();

  const isRegistrationMode = useMemo(
    () => pathname.includes(REGISTRATION_PATH),
    [pathname]
  );

  const isAuthorizationMode = useMemo(
    () => pathname.includes(AUTHORIZATION_PATH),
    [pathname]
  );

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return {
    isRegistrationMode,
    isAuthorizationMode,
    currentYear,
  };
};
